// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_5-9","top":"styles_top__2Sjul","left":"styles_left__14UyQ","description":"styles_description__8Bgou"};